<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom>video_library</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom>{{'main.projectSettings' | translate}}</span>
      </div>
      <!-- / APP TITLE -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

      </div>

      @if (!edit) {
        <button mat-raised-button
          (click)="editFunc()"
          class="add-product-button mat-white-bg my-12 mt-sm-0">
          <span>{{'main.edit' | translate}}</span>
        </button>
      }

      @if (edit) {
        <button mat-raised-button
          (click)="save()"
          class="add-product-button mat-white-bg my-12 mt-sm-0">
          <span>{{'main.save' | translate}}</span>
        </button>
      }

      @if (edit) {
        <button mat-raised-button
          (click)="editFunc()"
          class="add-product-button mat-white-bg my-12 mt-sm-0">
          <span>{{'main.cancel' | translate}}</span>
        </button>
      }

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">
      <div class="platforms">
        <mat-form-field>
          <mat-select placeholder="{{'event.platforms' | translate}}" (selectionChange)="changePlatforms($event)"
            [value]="selectedPlatform">
            @for (plat of platforms; track plat.id) {
              <mat-option [value]="plat.id">
                {{plat.title}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (!edit && projectData && projectDataKeys) {
        <div class="project-data-table">
          <table class="table">
            @for (el of projectDataKeys; track el) {
              <tr>
                <td class="title">{{'prjSet.' + el | translate}}</td>
                <td>{{projectData[el]}}</td>
              </tr>
            }
          </table>
          <div class="sub-title">{{'mail_settings' | translate}}</div>
          <table class="table">
            @for (el of mailKeys; track el) {
              <tr>
                <td class="title">{{el}}</td>
                <td>{{mailData[el]}}</td>
              </tr>
            }
          </table>
          <div class="sub-title">{{'sms_settings' | translate}}</div>
          <table class="table">
            @for (el of smsKeys; track el) {
              <tr>
                <td class="title">{{el}}</td>
                <td>{{smsData[el]}}</td>
              </tr>
            }
          </table>
          <div class="sub-title">{{'whatsapp_settings' | translate}}</div>
          <table class="table">
            @for (el of whatsAppKeys; track el) {
              <tr>
                <td class="title">{{el}}</td>
                <td>{{whatsAppData[el]}}</td>
              </tr>
            }
          </table>
        </div>
      }
      @if (edit && projectData) {
        <div class="project-data-form">
          <form [formGroup]="form">
            <table>
              @for (el of projectDataKeys; track el) {
                <tr>
                  <td class="title">{{'prjSet.' + el | translate}}</td>
                  <td class="data">
                    <mat-form-field style="display: block">
                      <input matInput placeholder="{{'prjSet.' + el | translate}}" formControlName="{{el}}">
                    </mat-form-field>
                  </td>
                </tr>
              }
            </table>
          </form>
          <div class="sub-title">{{'mail_settings' | translate}}</div>
          <form [formGroup]="mail">
            <table>
              @for (el of mailKeys; track el) {
                <tr>
                  <td class="title">{{el }}</td>
                  <td class="data">
                    <mat-form-field style="display: block">
                      <input matInput placeholder="{{el}}" formControlName="{{el}}">
                    </mat-form-field>
                  </td>
                </tr>
              }
            </table>
          </form>
          <div class="sub-title">{{'sms_settings' | translate}}</div>
          <form [formGroup]="sms">
            <table>
              @for (el of smsKeys; track el) {
                <tr>
                  <td class="title">{{el }}</td>
                  <td class="data">
                    <mat-form-field style="display: block">
                      <input matInput placeholder="{{el}}" formControlName="{{el}}">
                    </mat-form-field>
                  </td>
                </tr>
              }
            </table>
          </form>
          <div class="sub-title">{{'whatsapp_settings' | translate}}</div>
          <form [formGroup]="whatsApp">
            <table>
              @for (el of whatsAppKeys; track el) {
                <tr>
                  <td class="title">{{el }}</td>
                  <td class="data">
                    <mat-form-field style="display: block">
                      <input matInput placeholder="{{el}}" formControlName="{{el}}">
                    </mat-form-field>
                  </td>
                </tr>
              }
            </table>
          </form>
        </div>
      }
    </div>
  </div>
  <!-- / CENTER -->
</div>
